module.exports = __webpack_public_path__ + "img/5.ad010a92.jpg";